import {Router} from './router';
const $ = require('jquery');
const resultsBlock = document.getElementById('results');
const moreResultsBlock = document.getElementById('more-results');
const lang = document.documentElement.lang;

let jsonQuery;

if (moreResultsBlock && moreResultsBlock.hasAttribute('data-query')) {
    jsonQuery = JSON.parse(moreResultsBlock.getAttribute('data-query'))
}

let query = jsonQuery;
let total = parseInt(document.getElementById('count-results')?.getAttribute('data-total-count'));
let res;

import * as tts from './tts';

document.addEventListener('DOMContentLoaded', () => {
    if (query) {
        if (query.from === undefined) {
            query.from = 0;
        }
        res = query.from + query.size;
        if (res !== res % total) {
            moreResultsBlock.querySelector('.more-results-number').innerHTML = String(query.size - res % total);
        }
        if (query.size >= total) {
            fadeEffect();
        }

        moreResultsBlock.addEventListener('click', (e) => {
            more(e);
        })
    }
});

const more = (e) => {
    e.preventDefault();
    if (moreResultsBlock.classList.contains('.disabled')) {
        return false;
    }
    $(this).find('p').css('visibility', 'hidden');
    $(this).find('i').toggleClass('fa-spinner fa-spin fa-long-arrow-down');
    moreResultsBlock.classList.add('disabled');
    const path = moreResultsBlock.getAttribute('data-path');

    let esc = encodeURIComponent;
    let params = Object.keys(query)
        .map(k => esc('query[' + k + ']') + '=' + (query[k] ? esc(query[k]) : ''))
        .join('&');
    fetch(path + '?' + params, {
        method: 'GET',
        headers: {'X-Requested-With': 'XMLHttpRequest'},
    }).then(function (response) {
        if (response.status === 403) {
            return;
        }

        const contentType = response.headers.get('content-type');

        if (contentType && contentType.indexOf('application/json') !== -1) {
            response.json().then(data => {
                const selector = document.querySelector('main');
                const currentPage = query.from > 0 ? Math.round((query.from / query.size) + 1) : 1;
                selector.setAttribute('data-current-page', currentPage);
                selector.setAttribute('data-query', JSON.stringify(query));
                let slugs = [];

                $.each(data, function (i, item) {
                    initItem(item);
                    slugs.push(item['slug']);
                });

                slugs = slugs.join(',');
                selector.hasAttribute('data-photos') ? tts.page(slugs) : tts.page();

                updateMoreResultsBlock(data);
                let event = new Event('results:more:done');
                moreResultsBlock.dispatchEvent(event);
            });
        } else {
            response.text().then(html => {
                resultsBlock.append(html);
                updateMoreResultsBlock(html);
                let event = new Event('results:more:done');
                moreResultsBlock.dispatchEvent(event);
            });
        }
    }).catch(function (error) {
        console.error(error);
    });
}

const updateMoreResultsBlock = data => {
    moreResultsBlock.querySelector('p').setAttribute('style', 'visibility: none');
    $(this).find('i').toggleClass('fa-spinner fa-spin fa-long-arrow-down');
    moreResultsBlock.classList.remove('disabled');

    query.from += query.size;
    res = query.from + query.size;

    if (res !== res % total) {
        moreResultsBlock.querySelector('.more-results-number').innerHTML = String(query.size - res % total);
    }

    if (query.from >= total || data.length === 0) {
        fadeEffect();
    }
}

function initItem(item) {
    const prototype = resultsBlock.querySelector('.item-prototype');
    let template = prototype.cloneNode(true);

    initItemDataValues(template);

    template.querySelectorAll('.item-property').forEach(function (element) {
        initItemProperty(element, item);
    });

    let itemLink = template.querySelector('.item-link');
    if (itemLink) {
        if (itemLink.getAttribute('data-page-type') === 'member') {
            itemLink.setAttribute('href', Router.generate('collection_show.' + lang, {
                'type': item.type,
                'designer': item.designer.slug,
                'season': item.season.slug,
                'city': item.city.slug
            }));
        }
        let value = propertyPathValue(itemLink.getAttribute('data-property'), item);
        itemLink.setAttribute('href', itemLink.getAttribute('href').replace(itemLink.getAttribute('data-placeholder'), value));

        template.classList.remove('item-prototype');
        $(resultsBlock).append(template);

        let event = new CustomEvent("prototype:init", {
            detail: {
                item: item,
                template: template,
                value: value
            }
        });
        document.dispatchEvent(event);
    }
}

function initItemProperty(element, data) {
    let property = element.getAttribute('data-property');
    if (property === 'media-type') {
        property = data.hasOwnProperty('type') ? 'designer.name' : 'city.name';
    }
    let value = propertyPathValue(property, data);
    if (value) {
        if (element.getAttribute('data-type') === 'date') {
            value = new Date(value).toLocaleDateString($('html').attr('lang'), {dateStyle: 'short'});
        } else if (element.getAttribute('data-type') === 'array') {
            value = value.join(' / ');
        }
        let attr = element.getAttribute('data-attribute');
        if (attr) {
            element.setAttribute(attr, value);
        } else {
            element.textContent += value;
        }
    }
}

function propertyPathValue(property, data) {
    let value;
    let splittedPath = property.split('.');
    if (splittedPath.length === 1) {
        if (data.hasOwnProperty(property)) {
            value = data[property];
        }
    } else if (splittedPath.length > 1) {
        let pathExists = true,
            dataProperty = data;
        for (let propertyPath of splittedPath) {
            if (dataProperty === null || false === dataProperty.hasOwnProperty(propertyPath)) {
                pathExists = false;
                console.error('data ' + propertyPath + ' not found in response data item');
                break;
            }
            dataProperty = dataProperty[propertyPath];
        }
        if (pathExists) {
            value = dataProperty;
        }
    }

    return value;
}

function initItemDataValues(element) {
    const dataAttributes = element.dataset;

    for (let attr of Object.keys(dataAttributes)) {
        let value = dataAttributes[attr];

        if (typeof value === 'object') {
            value = value === null ? '' : JSON.stringify(value);
            element.setAttribute(attr, value);
        }
    }
}

const fadeEffect = () => {
    if (!moreResultsBlock.style.opacity) {
        moreResultsBlock.style.display = 'none';
    } else {
        moreResultsBlock.style.display = 'block';
    }
};
